import trigger from './module/customEvent';
import slideToggle from './module/slideToggle';
import pcAddIshover from './module/pcAddIshover';
import scroll2AddClass from './module/scroll2AddClass';
import accessibleGnavToggle from './module/accessibleGnavToggle';
import smoothScroll from './module/smoothScroll';

(function () {

  window.addEventListener('DOMContentLoaded', function(e) {
    slideToggle();
    pcAddIshover();
    smoothScroll();

		const sumuicon = document.getElementById('js-sumu-icon');
		const sumubtn = document.getElementById('js-sumu-btn');
		const trh = document.getElementById('js-open-trg');
		trh.addEventListener('click', () => {
			if(sumuicon.classList.contains('is')) {
				trigger(sumubtn, 'click');
			}
		})
  });

  window.addEventListener('load', function(e) {
    scroll2AddClass();
  });

  accessibleGnavToggle();
})();
